import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useBasicSanitationChartsDataContext } from './hooks/useBasicSanitationChartsDataContext';

export const HasBathroom = () => {
    const { chartData } = useBasicSanitationChartsDataContext();

    return (
        <Donut
            title={'Existência de Banheiro'}
            subtitles={chartData?.hasBathroom?.map(
                (item) => item.description
            )}
            chartData={chartData?.hasBathroom || []}
            colors={
                defaultColors.slice(0, chartData?.hasBathroom?.length) ||
                []
            }
            height={350}
        />
    );
};
